<mat-form-field class="field">
    <i [attr.class]="icon" *ngIf="icon && !iconDefinition" matPrefix></i>
    <fa-icon [icon]="iconDefinition" *ngIf="iconDefinition" matPrefix></fa-icon>
    <input #input
           class="field"
           type="text"
           matInput
           tab-directive
           [matTooltip]="value?.label"
           [matTooltipDisabled]="!value?.label"
           [formControl]="formControl"
           [isFormPatchValueActive]="true"
           [class.autocompleteTransparent]="autocompleteTransparent"
           [placeholder]="placeholder"
           [attr.aria-label]="placeholder"
           [focusIf]="forceFocus"
           [blurIf]="forceBlur"
           [matAutocomplete]="auto"
           [matAutocompleteDisabled]="autocompleteDisabled"
           (blur)="onBlurEvent($event)"
           (focus)="onFocusEvent($event)"
           (input)="inputChanged($event)"
           (keyup)="keyUp($event)">

    <fa-icon [icon]="iconSpinner" *ngIf="isLoading" matSuffix></fa-icon>

    <mat-autocomplete #auto="matAutocomplete"
                      #matAutocomplete
                      [displayWith]="displayFn"
                      [autoActiveFirstOption]="autoActiveFirstOption"
                      [disableRipple]="true"
                      (optionSelected)="optionSelected($event)"
                      (opened)="onOpenPanel.emit()"
                      (closed)="onClosePanel.emit()">
        <ng-container *ngFor="let option of options | async; trackBy: getOptionTrackBy">
            <mat-option [class.hidden]="removeEmptyOptions ? !(option.value && option.label) : false"
                        [value]="option">
                <ng-container [ngTemplateOutlet]='template'
                              [ngTemplateOutletContext]='{ $implicit: option }'>
                </ng-container>
            </mat-option>
        </ng-container>
        <ng-content selector=".end-list-positionned"></ng-content>
    </mat-autocomplete>
</mat-form-field>
